import React, { useState } from 'react';

const CryptoSelector = ({ walletData }) => {
  const [selectedCrypto1, setSelectedCrypto1] = useState('USDT TRC20');
  const [selectedCrypto2, setSelectedCrypto2] = useState('USDC');
  const [isDropdown1Open, setIsDropdown1Open] = useState(false);
  const [isDropdown2Open, setIsDropdown2Open] = useState(false);

  const cryptoOptions = [
    { value: 'USDT TRC20', label: 'USDT TRC20', icon: '/TRC20.png', color: 'bg-green-500' },
    { value: 'USDC ERC20', label: 'USDC ERC20', icon: '/ER20.png', color: 'bg-blue-500' },
  ];

  const cryptoOptionss = [
    { value: 'USDC', label: 'USDC', icon: '/dolllr.png', color: 'bg-green-500' },
    { value: 'ERC20', label: 'ERC20', icon: '/ER20.png', color: 'bg-blue-500' },
  ];

  const balance = '793.30 USDT';

  const handleCryptoSelect = (crypto, selector) => {
    if (selector === 1) {
      setSelectedCrypto1(crypto.value);
      setIsDropdown1Open(false);
    } else {
      setSelectedCrypto2(crypto.value);
      setIsDropdown2Open(false);
    }
  };

  // ✅ separate getter for each dropdown
  const getSelectedCrypto = (selector) => {
    if (selector === 1) {
      return cryptoOptions.find(option => option.value === selectedCrypto1) || cryptoOptions[0];
    } else {
      return cryptoOptionss.find(option => option.value === selectedCrypto2) || cryptoOptionss[0];
    }
  };

  // Get fee amount based on selected crypto network
  const getFeeAmount = (selectedValue) => {
    if (!walletData || !Array.isArray(walletData)) return "00";

    // Map selected value to wallet network format
    let networkKey = "";
    if (selectedValue === "USDT TRC20") {
      networkKey = "USDT-TRC20";
    } else if (selectedValue === "USDC ERC20") {
      networkKey = "USDT-ERC20"; // Based on your data
    }

    // Find the wallet with matching network
    const wallet = walletData.find(w => w.walletNetwork === networkKey);
    return wallet ? wallet.balance : "00";
  };

  return (
    <div className="flex flex-col lg:flex-row gap-4 py-3">
      {/* First Crypto Card */}
      <div className="bg-white rounded-[25px] p-4 lg:p-6 shadow-sm flex-1">
        <div className="flex items-center justify-between mb-3 lg:mb-4">
          <div className="flex items-center space-x-2 lg:space-x-3 bg-[#F6F7F8] rounded-[15px] px-2 py-1">
            <div className="w-6 h-6 lg:w-8 lg:h-8 rounded-full overflow-hidden flex items-center justify-center flex-shrink-0 bg-gray-100">
              <img
                src={getSelectedCrypto(1).icon}
                alt="Crypto Icon"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="relative">
              <button
                onClick={() => setIsDropdown1Open(!isDropdown1Open)}
                className="flex items-center space-x-1 lg:space-x-2 text-gray-700 hover:text-gray-900 focus:outline-none"
              >
                <span className="font-medium text-sm lg:text-base">{getSelectedCrypto(1).label}</span>
                <svg
                  className={`w-4 h-4 transition-transform ${isDropdown1Open ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {isDropdown1Open && (
                <div className="absolute top-full left-0 mt-2 w-40 lg:w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-10">
                  {cryptoOptions.map((crypto) => (
                    <button
                      key={crypto.value}
                      onClick={() => handleCryptoSelect(crypto, 1)}
                      className="w-full flex items-center space-x-3 px-3 py-2 text-left hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg"
                    >
                      <div className="w-5 h-5 lg:w-6 lg:h-6 rounded-full overflow-hidden flex items-center justify-center flex-shrink-0 bg-gray-100">
                        <img
                          src={crypto.icon}
                          alt="Crypto Icon"
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <span className="text-gray-700 text-sm lg:text-base">{crypto.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="text-md lg:text-2xl font-medium text-[#1A1C1E]">
          {getFeeAmount(selectedCrypto1)}
        </div>
      </div>

      {/* Second Crypto Card */}
      <div className="bg-white rounded-[25px] p-4 lg:p-6 shadow-sm flex-1">
        <div className="flex items-center justify-between mb-3 lg:mb-4">
          <div className="flex items-center space-x-2 lg:space-x-3 bg-[#F6F7F8] px-2 py-1 rounded-[15px]">
            <div className="w-6 h-6 lg:w-8 lg:h-8 rounded-full overflow-hidden flex items-center justify-center flex-shrink-0 bg-gray-100">
              <img
                src={getSelectedCrypto(2).icon}
                alt="Crypto Icon"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="relative">
              <button
                onClick={() => setIsDropdown2Open(!isDropdown2Open)}
                className="flex items-center space-x-1 lg:space-x-2 text-gray-700 hover:text-gray-900 focus:outline-none"
              >
                <span className="font-medium text-sm lg:text-base">{getSelectedCrypto(2).label}</span>
                <svg
                  className={`w-4 h-4 transition-transform ${isDropdown2Open ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {isDropdown2Open && (
                <div className="absolute top-full left-0 mt-2 w-40 lg:w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-10">
                  {cryptoOptionss.map((crypto) => (
                    <button
                      key={crypto.value}
                      onClick={() => handleCryptoSelect(crypto, 2)}
                      className="w-full flex items-center space-x-3 px-3 py-2 text-left hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg"
                    >
                      <div className="w-5 h-5 lg:w-6 lg:h-6 rounded-full overflow-hidden flex items-center justify-center flex-shrink-0 bg-gray-100">
                        <img
                          src={crypto.icon}
                          alt="Crypto Icon"
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <span className="text-gray-700 text-sm lg:text-base">{crypto.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="text-md lg:text-2xl font-medium text-[#1A1C1E]">
          {balance}
        </div>
      </div>
    </div>
  );
};

export default CryptoSelector;
